<template>
  <div style="height: 100%;" id="event-wrapper" v-if="currentEvent != null && currentEvent.id">
    <div class="left-menu" v-if="currentEvent != null">
      <el-tooltip class="item" effect="dark" :content="$t('event.menu.goback')" placement="right">
        <a class="left-menu-box" v-if="$route.params.id != undefined" @click="goBack">
          <img :src="$imageus + (currentEvent.logo == null ? host + '/static/500x500.png' : currentEvent.logo) + '?width=200&height=200'" alt />
        </a>
      </el-tooltip>

      <div class="left-menu-box">
        <el-tooltip class="item" effect="dark" :content="$t('leftmenu.reception')" placement="right">
          <router-link id="event-tour-2" :to="{ name: 'event' }" class="wrapper">
            <div class="icon-container" :style="$route.name == 'event' ? 'background-color: ' + currentEvent.color + '; border-color: ' + currentEvent.color : ''">
              <i :style="($route.name == 'event' ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/home.svg); background-color: ' + currentEvent.color + ';'"></i>
            </div>
          </router-link>
        </el-tooltip>
      </div>

      <div class="left-menu-box" v-for="(item, index) in currentEvent.modules.filter(x => x.name != 'SocialHub').slice(0, leftMenuItems)" :key="item.name + index">
        <el-tooltip class="item" effect="dark" :content="$i18n.locale == 'tr' ? item.titleTr : item.title" placement="right">
          <router-link :to="{ name: item.name }" class="wrapper" v-if="!item.isCustom">
            <div class="icon-container" :style="$route.name == item.name ? 'background-color: ' + currentEvent.color + '; border-color: ' + currentEvent.color : ''">
              <i :style="($route.name == item.name ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/' + item.name.toLowerCase() + '.svg); background-color: ' + currentEvent.color + ';'"></i>
            </div>
            <!-- <div class="title" :style="'color: ' + currentEvent.color">
            {{ item.title }}
          </div> -->
          </router-link>
          <a @click="goUrl(item.url)" :key="item.name + index" v-else class="wrapper">
            <div class="icon-container">
              <i :style="'mask-image: url(/static/module/module.svg); background-color: ' + currentEvent.color + ';'"></i>
            </div>
          </a>
        </el-tooltip>
      </div>
      <div class="left-menu-box" v-if="currentEvent.modules.filter(x => x.name != 'SocialHub').slice(leftMenuItems).length > 0">
        <div id="event-tour-2" :to="{ name: 'event' }" class="wrapper">
          <div
            class="icon-container"
            :style="
              currentEvent.modules
                .filter(x => x.name != 'SocialHub')
                .slice(leftMenuItems)
                .some(x => x.name == $route.name)
                ? 'background-color: ' + currentEvent.color + '; border-color: ' + currentEvent.color
                : ''
            "
          >
            <i
              :style="
                (currentEvent.modules
                  .filter(x => x.name != 'SocialHub')
                  .slice(leftMenuItems)
                  .some(x => x.name == $route.name)
                  ? 'filter: brightness(0) invert(1);'
                  : '') +
                  ';mask-image: url(/static/module/other.svg); background-color: ' +
                  currentEvent.color +
                  ';'
              "
            ></i>
          </div>
          <div class="dropdown">
            <div class="dropdown-left"></div>
            <div class="dropdown-right">
              <div class="dropdown-menu-list">
                <template v-for="(item, index) in currentEvent.modules.filter(x => x.name != 'SocialHub').slice(leftMenuItems)">
                  <router-link class="dropdown-menu-list-item" :key="item.name + index" :to="{ name: item.name }" v-if="!item.isCustom">
                    <div class="icon-container" :style="$route.name == item.name ? 'background-color: ' + currentEvent.color + '; border-color: ' + currentEvent.color : ''">
                      <i v-if="item.name != null" :style="($route.name == item.name ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/' + item.name.toLowerCase() + '.svg); background-color: ' + currentEvent.color + ';'"></i>
                    </div>
                    <div class="title" :style="'color: ' + currentEvent.color">
                      {{ $i18n.locale == "tr" ? item.titleTr : item.title }}
                    </div>
                  </router-link>
                  <a @click="goUrl(item.url)" :key="item.name + index + '-key'" class="dropdown-menu-list-item" v-else>
                    <div class="icon-container">
                      <i :style="'mask-image: url(/static/module/module.svg); background-color: ' + currentEvent.color + ';'"></i>
                    </div>
                    <div class="title" :style="'color: ' + currentEvent.color">
                      {{ $i18n.locale == "tr" ? item.titleTr : item.title }}
                    </div>
                  </a>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="router-container" @mousemove="showBar" :style="!isOpen ? 'width: 100%' : 'width:100%'">
      <EventBar :menudisplay="!isOpen" v-if="windowWidth > 991" />
      <HeaderMobile v-if="windowWidth <= 991" />
      <vue-page-transition name="fade-in-right" class="router-wrapper" :style="windowWidth > 991 ? '' : 'padding-bottom:1rem; padding-top:3rem;'">
        <router-view :key="$route.params.session_id" />
      </vue-page-transition>
    </div>

    <div class="right-panel" id="rightt" :style="!isOpen ? 'margin-right:-270px;' : ''" style="z-index: 99" v-if="windowWidth > 991">
      <AccountBlock :menudisplay="!isOpen" v-if="windowWidth > 991" />

      <div class="social-category-container" :style="!isOpen ? 'display:none' : 'display:flex'">
        <transition name="el-zoom-in-top" mode="out-in">
          <div class="new-post-area" v-if="newPost.length > 0" @click="$store.state.socialModule.identifier += 1">
            <div class="owner-list">
              <img width="32" height="32" v-for="(item, index) in newPost.filter(x => x.owner != null).slice(0, 3)" :key="item.id + '-new-post-area-' + index" :src="$imageus + (item.owner.image == null ? host + '/static/500x500-user.png' : item.isAnnouncement ? currentEvent.logo : item.owner.image.replaceAll($imageus, '')) + '?width=200&height=200&mode=cover'" :alt="item.owner.title" />
            </div>
            <div class="text">+{{ newPost.length }} {{ $t("socialhub.newPost") }}</div>
          </div>
        </transition>

        <swiper class="right-category-wrapper" :options="swiperOption">
          <swiper-slide class="right-category-box">
            <button
              @click="
                currentHub = null;
                currentHubHasTopic = null;
              "
              class="socialhub-category"
              :style="currentHub == null ? 'background-color :' + currentEvent.color + '; color: white; border-color :' + currentEvent.color + ';' : ''"
            >
              <div class="icon-container">
                <i :style="(currentHub == null ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/socialHub.svg); background-color: ' + currentEvent.color + ';'"></i>
              </div>
              <span v-show="currentHub == null">{{ $t("socialhub.menu.hub") }}</span>
            </button>

            <button
              @click="
                currentHub = 0;
                currentHubHasTopic = true;
              "
              class="socialhub-category"
              :style="currentHub == 0 ? 'background-color :' + currentEvent.color + '; color: white; border-color :' + currentEvent.color + ';' : ''"
            >
              <div class="icon-container">
                <i :style="(currentHub == 0 ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/socialChat.svg); background-color: ' + currentEvent.color + ';'"></i>
              </div>
              <span v-show="currentHub == 0">{{ $t("socialhub.menu.questionAnswer") }}</span>
            </button>

            <button
              @click="
                currentHub = 1;
                currentHubHasTopic = null;
              "
              class="socialhub-category"
              :style="currentHub == 1 ? 'background-color :' + currentEvent.color + '; color: white; border-color :' + currentEvent.color + ';' : ''"
            >
              <div class="icon-container">
                <i :style="(currentHub == 1 ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/socialStats.svg); background-color: ' + currentEvent.color + ';'"></i>
              </div>
              <span v-show="currentHub == 1">{{ $t("socialhub.menu.voting") }}</span>
            </button>

            <button
              @click="
                currentHub = 2;
                currentHubHasTopic = null;
              "
              class="socialhub-category"
              :style="currentHub == 2 ? 'background-color :' + currentEvent.color + '; color: white; border-color :' + currentEvent.color + ';' : ''"
            >
              <div class="icon-container">
                <i :style="(currentHub == 2 ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/socialSurvey.svg); background-color: ' + currentEvent.color + ';'"></i>
              </div>
              <span v-show="currentHub == 2">{{ $t("socialhub.menu.survey") }}</span>
            </button>
          </swiper-slide>
        </swiper>
      </div>
      <div class="search-area-container" v-if="isOpen">
        <div class="search-area">
          <el-dropdown>
            <el-button type="default" size="mini">
              {{ getEnumsDisplay("SocialHubPostSortingType", filter.socialHubPostSortingType) }}
              <i class="fas fa-sort-amount-down"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in getEnums.find(x => x.title == 'SocialHubPostSortingType').enums" :key="'post-sorting-type-' + index" :value="item.key" @click.native="currentHubSortingType = item.key" :label="item.displayName">{{ item.displayName }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="right_inner" v-if="isOpen" :style="!isOpen ? 'display:none;' : 'display:block;'">
        <transition-group name="component-fade">
          <template v-if="currentEvent.modules.find(x => x.name == 'SocialHub') != null">
            <Social v-if="windowWidth > 768 && isOpen" key="social-component" />
            <div class="share-block" tabindex="0" key="share-block-component">
              <div v-if="isMentionVisible && sharepanel" v-dragscroll.x class="mention-panel">
                <div v-for="(user, index) in users" :key="index" @click="tagUser(user)" class="mention-item">
                  <div :style="user.image == null ? 'background-color: f1f1f1;' : 'background-image: url(' + $imageus + user.image + '?width=200&height=200&mode=cover&background=ffffff'" class="user-image"></div>
                  <p>{{ user.fullName }}</p>
                </div>
              </div>
              <transition name="el-zoom-in-bottom" mode="out-in">
                <div class="share-panel" v-if="sharepanel">
                  <div v-if="currentEvent.socialHub.topics.length > 0" style="margin-bottom:10px; pointer-events: all;">
                    <el-select v-model="form.topic" :placeholder="$t('selectTopic')" @clear="form.topic = null" value-key="id" clearable>
                      <el-option v-for="(topic, index) in currentEvent.socialHub.topics" :key="topic.id + index" :label="topic.title" :value="topic">
                        <template>
                          <i class="fas fa-circle" :style="'color:' + topic.color"></i>
                          <span>{{ topic.title }}</span>
                        </template>
                      </el-option>
                    </el-select>
                  </div>
                  <textarea @keydown.enter.exact.prevent @keyup.enter.exact="post" v-model="form.postText" :disabled="loading == 'postSend'" type="textarea" rows="12" style="resize:none;" resize="none" :placeholder="$t('share')" />
                  <div class="share-panel-buttons">
                    <div class="message-input-icon">
                      <i :class="sending ? 'fa fa-spinner fa-spin' : 'camera-icon'" v-if="imageURL == null" @click="select"></i>
                      <img :src="imageURL" alt="Selected Image" v-else />
                      <template v-if="imageURL">
                        <i class="fa fa-spinner fa-spin" v-if="imageURL && loading == 'uploadToServer'"></i>
                        <i class="fa fa-times" v-else @click="clearImage"></i>
                      </template>
                    </div>
                    <button @click="post" :style="'background-color: ' + currentEvent.color + ';'">
                      <i :class="loading == 'postSend' || loading == 'uploadToServer' ? 'fa fa-spinner spin' : 'fa fa-paper-plane'"></i>
                      {{ $t("send") }}
                    </button>
                  </div>

                  <input type="file" @change="uploadFile" style="display: none" ref="file" />
                </div>
              </transition>

              <div v-if="currentEvent.modules.find(x => x.name == 'SocialHub') != null && isAttending" class="share-button" :style="'background-color: ' + currentEvent.color + ';'" @click="sharepanel == false ? (sharepanel = true) : (sharepanel = false)">
                <i :style="sharepanel == true ? 'margin-right:0px;' : ''" :class="sharepanel == false ? 'fas fa-pen' : 'fas fa-times'"></i>
                <span v-if="sharepanel == false">{{ $t("share_a_post") }}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <Nodata :title="$t('socialhub.nodatatitle')" :description="$t('socialhub.nodatadesc')" key="no-data" anim="social" :type="filter.type" />
          </template>
        </transition-group>
      </div>
    </div>
    <el-dialog :visible.sync="albumDetailDialogModal" class="xlarge" append-to-body fullscreen>
      <div class="custom-modal" v-if="album != null">
        <div class="modal-body no-footer">
          <img :src="album.url" :key="album.url" width="100%" height="auto" style="aspect-raio:16/9" />
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="appointmentCreateDialog" class="default" :close-on-click-modal="false" center destroy-on-close append-to-body :title="$t('appointment.title')" :close="setEventID">
      <MakeAppointment v-if="appointmentCreateDialog" @closeDialog="appointmentCreateDialog = false" :participant="selectedParticipant" :type="selectedType" :eventId="selectedEventId" :standTitle="selectedStandTitle" />
    </el-dialog>
    <el-dialog :visible.sync="speakerModalVisible" :title="$t('speaker.title')" class="default" :close-on-click-modal="false" center append-to-body destroy-on-close>
      <SpeakerDetailDialog @closeDialog="speakerModalVisible = false" v-if="speakerModalVisible" />
    </el-dialog>

    <el-dialog :visible.sync="programModalVisible" :title="$t('program.title')" class="default primary" :close-on-click-modal="false" center append-to-body destroy-on-close>
      <ProgramDetailDialog @closeDialog="programModalVisible = false" v-if="programModalVisible" />
    </el-dialog>

    <md-snackbar class="warning" :md-position="'center'" :md-duration="4000" :md-active.sync="error.hasError" md-persistent>
      <i class="fa fa-exclamation-triangle"></i>
      <span>{{ error.message }}</span>
    </md-snackbar>
    <SocialMobile v-if="windowWidth < 991" />
  </div>
</template>

<script>
import SpeakerDetailDialog from "../components/SpeakerDetailDialog";
import ProgramDetailDialog from "../components/ProgramDetailDialog";
import Social from "./event/socialHub/Social.vue";
import HeaderMobile from "../modules/HeaderMobile.vue";
import SocialMobile from "../modules/SocialMobile.vue";
import Vote from "./event/Vote";
import AccountBlock from "../modules/AccountBlock";
import EventBar from "../modules/EventBar";
import axios from "axios";
import moment from "moment";
import $ from "jquery";
import MakeAppointment from "../components/MakeAppointment.vue";
import { dragscroll } from "vue-dragscroll";

export default {
  name: "EventWrapper",
  components: {
    SpeakerDetailDialog,
    ProgramDetailDialog,
    HeaderMobile,
    Social,
    Vote,
    EventBar,
    AccountBlock,
    MakeAppointment,
    SocialMobile
  },
  directives: {
    dragscroll
  },

  data() {
    return {
      selectedStandTitle: null,
      selectedParticipant: null,
      selectedEventId: null,
      selectedType: 0,
      appointmentCreateDialog: false,
      currentHubHasTopic: null,
      currentHub: null,
      currentHubSortingType: 0,
      sending: false,
      imageURL: null,
      image: null,
      activeModule: "social",
      swiperOption: {
        slidesPerView: "auto"
      },
      speakerModalVisible: false,
      albumDetailDialogModal: false,
      programModalVisible: false,
      sub: null,
      error: {
        message: null,
        hasError: false
      },
      social: null,
      user: null,
      messageBlock: false,
      message: null,
      userModal: false,
      host: location.host == "localhost:3000" ? "https://live.holacon.com/" : "https://" + location.host,
      moment,
      localStorage,
      sharepanel: false,
      isMentionVisible: false,
      users: [],
      form: {
        id: null,
        postText: null,
        title: null,
        image: null,
        topic: null,
        session: null,
        isDraft: true,
        isAnnouncement: true,
        type: 0,
        mentions: [
          // {
          //   id: null,
          //   type: 0,
          //   color: null,
          //   title: null,
          //   image: null,
          //   fullName: null
          // }
        ]
      },
      loading: false,
      timeout: null,
      windowWidth: 0,
      album: null,
      leftMenuItems: 6,
      barTimeout: null
    };
  },

  mounted() {
    this.subscribe();
  },

  created() {
    this.$store.dispatch("getEventBySlug", { id: null, slug: this.$route.params.id, route: false });

    if ($(window).width() <= 991) {
      this.$store.state.sidebarIsOpen = false;
    }
    this.windowWidth = $(window).width();
    window.addEventListener("resize", event => {
      this.windowWidth = $(window).width();
    });

    this.$root.$on("toggleMenu", () => {
      localStorage.setItem("isOpen", !this.isOpen);
      this.$store.state.sidebarIsOpen = !this.$store.state.sidebarIsOpen;
    });

    this.$root.$on("error", data => {
      this.error.message = data;
      this.error.hasError = true;
    });

    this.$root.$on("speakerModalVisible", id => {
      this.speakerModalVisible = true;
      if (this.programModalVisible == true) {
        this.programModalVisible = false;
      }
    });
    this.$root.$on("albumDetailDialogModal", album => {
      this.album = album;
      this.albumDetailDialogModal = true;
    });

    this.$root.$on("programModalVisible", id => {
      this.programModalVisible = true;
      if (this.speakerModalVisible == true) {
        this.speakerModalVisible = false;
      }
    });
  },

  beforeMount() {
    this.$store.state.sidebarIsOpen = localStorage.getItem("isOpen") == null ? true : localStorage.getItem("isOpen") == "true";
    this.$root.$off("makeAppointmentDialog");
    this.$root.$on("makeAppointmentDialog", (participant, eventId, standTitle, type) => {
      this.selectedType = type;
      if (participant != null) {
        this.selectedParticipant = JSON.parse(JSON.stringify(participant));
        this.selectedStandTitle = standTitle;
      } else {
        this.selectedParticipant = null;
        this.selectedStandTitle = null;
      }
      if (standTitle != null && standTitle != undefined) {
        this.selectedStandTitle = standTitle;
      } else {
        this.selectedStandTitle = null;
      }
      if (eventId != null && eventId != undefined) {
        this.selectedEventId = eventId;
      } else {
        this.selectedEventId = null;
      }
      this.appointmentCreateDialog = !this.appointmentCreateDialog;
    });

    window.addEventListener("resize", () => {
      this.leftMenuItemsCalc();
    });
    this.leftMenuItemsCalc();
  },

  beforeDestroy() {
    this.$root.$off("speakerModalVisible");
    this.$root.$off("programModalVisible");

    this.$socket.emit("unsubscribe", "live-stream-" + this.currentEvent.id);
    this.$socket.emit("unsubscribe", "livestream-" + this.currentEvent.id);
    this.$socket.emit("unsubscribe", "event-social-hub-" + this.currentEvent.id);

    this.$root.$off("toggleMenu");

    this.$root.$off("error");
  },

  methods: {
    clearImage() {
      this.image = null;
      this.imageURL = null;
      this.$refs.file.value = null;
    },
    async uploadFile() {
      let file = this.$refs.file.files[0];
      this.image = file;
      this.imageURL = URL.createObjectURL(file);
      this.$refs.file.value = null;
    },
    select() {
      this.$refs.file.click();
    },
    showBar(event) {
      var eventbar = document.getElementById("eventbar-toolbar");
      if (this.barTimeout == null) {
        if (this.currentSessions.length > 0) {
          this.barTimeout = setTimeout(this.setMargin, 6000);
          if (eventbar) {
            eventbar.style.margin = "0px 0px 0px 0px";
          }
          //console.log(event.clientX, event.clientY);
        }
      }
    },
    setMargin() {
      var eventbar = document.getElementById("eventbar-toolbar");
      if (eventbar) {
        eventbar.style.margin = "-56px 0px 0px 0px";
      }
      this.barTimeout = null;
    },
    leftMenuItemsCalc() {
      var availableHeight = window.innerHeight - 85 - 250;

      var itemCount = availableHeight / 50;
      if (itemCount > 11) {
        itemCount = 11;
      }

      if (itemCount < 1) {
        itemCount = 1;
      }

      this.leftMenuItems = itemCount;
    },
    setEventID() {},
    goUrl(url) {
      if (!url.includes("http://") && !url.includes("https://")) {
        url = "https://" + url;
      }
      window.open(url, "_blank");
    },
    tagUser(user, post) {
      this.form.mentions.push(user);
      this.isMentionVisible = false;
      this.form.postText = this.form.postText.replace("@" + this.searchTerm, user.fullName);
      this.searchTerm = "";
      this.users = [];
    },
    async post() {
      this.loading = "postSend";
      var postText = this.form.postText;
      var sendingImage = null;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (this.image != null) {
          this.loading = "uploadToServer";
          var fd = new FormData();
          fd.append("file", this.image);
          var res = await axios.post(`account/uploadfile?uploadType=message`, fd, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          });
          if (res.data.hasError) {
            this.$message.error(res.data.message);
            this.loading = false;
            return;
          } else {
            sendingImage = res.data.data.item.url;
          }
          this.loading = false;
        }

        this.form.mentions.forEach(user => {
          if (postText.includes(user.fullName)) {
            postText = postText.replace(user.fullName, "%" + user.id + "%");
          } else {
            var fIndex = this.form.mentions.findIndex(x => x.id == user.id);
            if (fIndex != -1) {
              this.form.mentions.splice(fIndex, 1);
            }
          }
        });
        var response = await axios.post("socialhub/addorupdate", {
          ...this.form,
          image: sendingImage,
          postText: postText ? postText : this.form.postText
        });
        if (response.data.hasError == false) {
          this.form.postText = null;
          this.form.topic = null;
          this.form.mentions = [];
        } else {
          this.$message.error(response.data.message);
        }
        this.clearImage();
        this.sharepanel = false;
        this.loading = false;
      }, 500);
    },
    goBack() {
      if (this.$route.name == "session") {
        this.$router.push({ name: "livestreams" });
      } else if (this.$route.name == "network-area") {
        this.$router.push({ name: "networking" });
      } else if (this.$route.name == "stand-detail") {
        this.$router.push({ name: "stands" });
      } else if (this.$route.name == "event") {
        this.$router.push({ name: "home" });
      } else {
        this.$router.push({ name: "home" });
      }
    },

    async sendMessage() {
      var response = await axios.post("chat/sendmessage", {
        userID: this.user.id,
        messageText: this.message
      });
      this.error.hasError = true;
      this.error.message = this.$t("message_sent");
      this.message = null;
      this.messageBlock = false;
    },
    subscribe() {
      this.$socket.emit("subscribe", {
        channel: "livestream-" + this.currentEvent.id,
        token: ""
      });

      this.$socket.emit("subscribe", {
        channel: "event-social-hub-" + this.currentEvent.id,
        token: ""
      });

      this.$socket.off("livestream-" + this.currentEvent.id + "-liveStreamRemoved");
      this.$socket.off("livestream-" + this.currentEvent.id + "-liveStreamUpdated");
      this.$socket.off("livestream-" + this.currentEvent.id + "-watchers");

      this.$socket.on("livestream-" + this.currentEvent.id + "-watchers", data => {
        var index = this.$store.state.sessions.findIndex(k => k.id == data.data.Id);
        if (index != -1) {
          this.$store.state.sessions[index].watcherCount = data.data.WatcherCount;
        }
        if (this.currentSession != null && this.currentSession.id == data.data.Id) {
          this.currentSession.watcherCount = data.data.WatcherCount;
        }
      });

      this.$socket.on("livestream-" + this.currentEvent.id + "-liveStreamRemoved", data => {
        this.$store.commit("removeSession", data.data.Id);
        if (this.currentSession != null && data.data.Id == this.currentSession.id) {
          this.$router.push({ name: "livestreams" });
        }
      });

      this.$socket.off("livestream-" + this.currentEvent.id + "-liveStreamSortingChanged");
      this.$socket.on("livestream-" + this.currentEvent.id + "-liveStreamSortingChanged", data => {
        var sessions = data.data.Items;
        for (var i = 0; i < sessions.length; i++) {
          var element = sessions[i];
          var index = this.$store.state.sessions.findIndex(k => k.id == element.Id);
          if (index != -1) {
            this.$store.state.sessions[index].orderNO = element.OrderNO;
          }
        }
        this.$store.commit("setSessions", this.$store.state.sessions);
      });

      this.$socket.on("livestream-" + this.currentEvent.id + "-liveStreamUpdated", data => {
        data = data.data;
        this.showBar();
        var index = this.$store.state.sessions.findIndex(k => k.id == data.Item.Id);

        if (index != -1) {
          var currentSessionData = {
            ...this.$store.state.sessions[index],
            title: data.Item.Title,
            venueID: data.Item.VenueID,
            image: data.Item.Image,
            orderNO: data.Item.OrderNO,
            isActiveForSpeakers: data.Item.ISActiveForSpeakers,
            isLive: data.Item.ISLive,
            backgrounBanner: data.Item.BackgrounBanner,
            topBanner: data.Item.TopBanner,
            bottomBanner: data.Item.BottomBanner,
            isActive: data.Item.ISActive,
            rmtpUrl: data.Item.RMTPUrl,
            startDate: data.Item.StartDate,
            sessionType: data.Item.SessionType,
            endDate: data.Item.EndDate,
            updateDate: data.Item.UpdateDate,
            showWatcherCount: data.Item.ShowWatcherCount,
            watcherCount: data.Item.WatcherCount,
            publishers: this.$toCamel(
              data.Item.Publishers.map(x => {
                return { ...x, isActive: x.ISActive };
              })
            ),
            externalLiveStreamProviders: this.$toCamel(data.Item.ExternalLiveStreamProviders),
            participants: data.Participants
          };

          this.$store.commit("updateSession", {
            data: currentSessionData,
            index
          });

          if (this.currentSession != null && this.currentSession.id == data.Item.Id) {
            this.$store.commit("setCurrentSession", currentSessionData);
          }
        } else {
          this.$store.commit("setAddSession", {
            id: data.Item.Id,
            title: data.Item.Title,
            venueID: data.Item.VenueID,
            image: data.Item.Image,
            orderNO: data.Item.OrderNO,
            isActiveForSpeakers: data.Item.ISActiveForSpeakers,
            isLive: data.Item.ISLive,
            backgrounBanner: data.Item.BackgrounBanner,
            topBanner: data.Item.TopBanner,
            bottomBanner: data.Item.BottomBanner,
            isActive: data.Item.ISActive,
            sessionType: data.Item.SessionType,
            rmtpUrl: data.Item.RMTPUrl,
            startDate: data.Item.StartDate,
            endDate: data.Item.EndDate,
            updateDate: data.Item.UpdateDate,
            watcherCount: data.Item.WatcherCount,
            externalLiveStreamProviders: this.$toCamel(data.Item.ExternalLiveStreamProviders),
            publishers: this.$toCamel(
              data.Item.Publishers.map(x => {
                return { ...x, isActive: x.ISActive };
              })
            ),
            participants: data.Participants
          });
        }
      });
    }
  },

  computed: {
    isOpen() {
      return this.$store.state.sidebarIsOpen;
    },
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    getEnums() {
      return this.$store.getters.getEnums;
    },
    filter() {
      return this.$store.getters.getSocialHubFilter;
    },
    currentSessions() {
      return this.$store.getters.getSessions;
    },
    currentSession() {
      return this.$store.getters.getCurrentSession;
    },
    newPost() {
      return this.$store.getters.getNewPost;
    },
    currentOrganisation() {
      return this.$store.getters.getOrganisation;
    },
    isAttending() {
      return this.$store.getters.getAttending;
    },
    innerWidth() {
      return window.innerWidth;
    }
  },

  watch: {
    currentHubHasTopic: function() {
      this.$store.commit("changeSocialItemTopicType", this.currentHubHasTopic);
    },
    currentHub: function() {
      this.$store.commit("changeSocialItemType", this.currentHub);
    },
    currentHubSortingType: function() {
      this.$store.commit("changeSocialItemSortingType", this.currentHubSortingType);
    },
    "currentEvent.id": function() {
      this.subscribe();
    },
    "form.postText": async function(text) {
      if (this.form.postText != "" || this.form.postText != null) {
        this.form.postText.split(" ").forEach(item => {
          if (item.startsWith("@")) {
            this.isMentionVisible = true;
            this.searchTerm = item.replace("@", "");
            setTimeout(() => {
              axios
                .post("socialhub/searchmention", {
                  searchTerm: this.searchTerm
                })
                .then(res => {
                  this.users = res.data.data.items;
                });
            }, 1000);
          } else {
            this.isMentionVisible = false;
            this.searchTerm = "";
          }
        });
      }
    }
  }
};
</script>

<style lang="less">
@media (max-width: 991px) {
  .left-menu {
    display: none !important;
  }
}

#event-wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;

  .left-menu {
    width: 80px;
    overflow: unset;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
    z-index: 9;
    flex: unset;
    background: white;

    .left-menu-box-passive {
      opacity: 0.5;
      filter: grayscale(100%);
      cursor: not-allowed !important;
      cursor: no-drop !important;
    }

    .left-menu-box {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-top: 10px;
      cursor: pointer;

      &:hover {
        .wrapper {
          .dropdown {
            display: flex;
          }
          & > .icon-container {
            transform: scale(1.2);
          }
        }
      }

      img {
        width: 50px;
        height: 50px;
        border-radius: 8px;
        box-shadow: rgba(0, 0, 0, 0.3) 0px 0px 6px;
        background: #fff;
        margin-bottom: 15px;
      }

      .wrapper {
        justify-content: start;
        display: flex;
        align-items: center;
        flex-direction: column;
        flex: 1;
        display: flex;
        position: relative;
        width: 100%;
        border-radius: 0px;
        text-decoration: none;

        .dropdown {
          display: none;
          transition: all 0.3s;
          position: absolute;
          left: calc(~"100%");
          flex-direction: row;
          bottom: -0.5rem;
          .dropdown-left {
            width: 0.5rem;
          }
          .dropdown-right {
            padding: 10px 10px;
            border-radius: 8px;
            height: auto;
            overflow: hidden;
            overflow-y: auto;
            width: 210px;
            max-height: 465px;
            &::-webkit-scrollbar {
              width: 3px;
            }
            background: white;
            box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 6px;
            .dropdown-menu-list {
              display: flex;
              flex-direction: column;
              gap: 10px;
              .dropdown-menu-list-item {
                display: flex;
                flex-direction: row;
                align-items: center;
                text-decoration: none;
                gap: 8px;
                & > .icon-container {
                  border-radius: 8px;
                  width: 50px;
                  height: 50px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-direction: column;
                  text-decoration: none;

                  i {
                    font-size: 30px;
                    margin-bottom: 0px;
                    display: block;
                    background-position: 50%;
                    background-repeat: no-repeat;
                    background-size: contain;
                    height: 30px;
                    width: 30px;
                    cursor: pointer;
                    mask-repeat: no-repeat;
                    mask-position: center;
                  }
                }
                .title {
                  color: #505763 !important;
                  margin-top: 3px;
                  font-size: 13px;
                  text-align: left;
                }
              }
            }
          }
        }
        .icon-container {
          border-radius: 8px;

          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          text-decoration: none;
          transition: all 0.3s;

          i {
            font-size: 30px;
            margin-bottom: 0px;
            display: block;
            background-position: 50%;
            background-repeat: no-repeat;
            background-size: contain;
            height: 30px;
            width: 30px;
            cursor: pointer;
            mask-repeat: no-repeat;
            mask-position: center;
          }
        }

        .title {
          color: #505763 !important;
          margin-top: 3px;
          font-size: 13px;
          text-align: center;
        }

        &.is-active {
          border-radius: 8px;

          i {
            color: #fff !important;
          }

          .title {
            color: #505763 !important;
            font-weight: 500;
            font-size: 13px;
          }
        }
      }
    }
  }

  .router-container {
    width: calc(~"100% - 400px");
    height: 100vh;
    overflow-y: auto;
    transition: 0.3s;
    background: #f1f3f6;
    flex: 1;
    .router-wrapper {
      width: 100%;

      & > div {
        &#holacon-session-container {
          margin-top: 0px;
        }
        margin-top: 52px;
        .container {
          margin-top: 0px;
          .info-card {
            margin-top: 0px;
          }
        }
      }
    }
    @media screen and (max-width: 991px) {
      background: #f1f3f6;
    }
  }

  .right-panel {
    width: 350px;
    transition: 0.3s;
    background-color: white;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .right_inner {
      height: calc(~"100vh - 171px");
      max-height: -webkit-fill-available;
      width: 100%;
      position: relative;
      .not-participant-show {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: -20vh;
        height: 100vh;
        text-align: center;
        padding: 0px 20px;

        i {
          font-size: 30px;
          font-size: 50px;
          color: #8c929c;
        }

        h5 {
          font-size: 20px;
          font-weight: 500;
          margin: 16px 0px 0px 0px;
          color: #292f3b;
        }

        p {
          font-size: 14px;
          font-weight: 400;
          color: #505763;

          a {
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
      .share-block {
        position: absolute;
        bottom: 1.5rem;
        right: 0px;
        width: 100%;
        padding: 0px 16px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        transition: all 0.4s;
        z-index: 5;
        .mention-panel {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-direction: row;
          height: 60px;
          width: 100%;
          background-color: #fff;
          border-radius: 8px;
          padding: 6px 8px;
          margin-bottom: 10px;
          box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.4);
          overflow-y: hidden;
          overflow-x: hidden;
          pointer-events: all;

          .mention-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-right: 15px;
            width: auto;
            position: relative;
            cursor: pointer;

            .user-image {
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
              border-radius: 50%;
              border: 3px solid #f1f1f1;
              width: 38px;
              height: 38px;
              display: inline-block;
              position: absolute;
            }

            p {
              font-size: 13px;
              font-weight: 500;
              margin-left: 44px;
              white-space: nowrap;
            }
          }
        }

        .share-panel {
          display: inline-block;
          position: relative;
          width: 100%;
          min-height: 200px;
          // max-height: 360px;
          background-color: white;
          margin-bottom: 25px;
          border-radius: 8px;
          box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.4);
          padding: 14px;
          transition: all 0.4s;
          .share-panel-buttons {
            display: flex;
            flex-direction: row;
            gap: 10px;
            align-items: center;
            .message-input-icon {
              height: 100%;
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 40px;
              flex-shrink: 0;
              i {
                cursor: pointer !important;
                color: #292f3b;
                &.fa-times {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translateX(-50%) translateY(-50%);
                }
                &.fa-spinner {
                  position: absolute;
                  transform: translateX(-50%) translateY(-50%);
                }
              }
              img {
                width: 40px !important;
                height: 40px;
                flex-shrink: 0;
                border-radius: 4px;
                box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3), 0px 0px 2px rgba(255, 255, 255, 0.3);
                object-fit: cover;
              }
            }
          }
          &::after {
            content: " ";
            position: absolute;
            width: 0;
            height: 0;
            left: auto;
            right: 38px;
            bottom: -20px;
            border: 12px solid;
            border-color: white white transparent transparent;
          }

          textarea {
            display: block;
            width: 100% !important;
            min-height: inherit;
            max-height: 286px;
            border: none;
            font-family: "Roboto", sans-serif;
            font-size: 13px;
            pointer-events: all;

            &:focus {
              outline: none !important;
              border: none !important;
            }
          }

          button {
            width: 100%;
            padding: 12px 0px;
            border-radius: 8px;
            border: none;
            background-color: #03658c;
            color: white;
            font-weight: 600;
            font-family: "Roboto", sans-serif;
            cursor: pointer;
            pointer-events: all;

            i {
              margin-right: 6px;
            }
          }
        }

        .share-button {
          background-color: #03658c;
          padding: 10px 14px;
          border-radius: 30px;
          color: white;
          font-size: 14px;
          font-weight: 500;
          max-width: 170px;
          cursor: pointer;
          transition: all 0.4s;
          box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
          pointer-events: all;

          i {
            margin-right: 6px;
          }

          span {
            transition: all 0.4s;
          }
        }
      }
    }

    &.closed {
      margin-left: -350px;
    }

    .social-category-container {
      display: flex;
      background-color: white;
      flex-direction: row;
      align-items: center;
      width: 100%;
      position: relative;
      padding: 10px 10px;

      .new-post-area {
        position: absolute;
        padding: 9px;
        cursor: pointer;
        left: 50%;
        bottom: -53px;
        z-index: 2;
        transform: translateX(-50%);
        gap: 8px;
        display: flex;
        background: #03658c;
        align-items: center;
        border-radius: 64px;
        box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
        .owner-list {
          display: flex;
          flex-direction: row;
          flex-shrink: 0;
          img {
            flex-shrink: 0;
            object-fit: cover;
            width: 22.5px;
            height: 22.5px;
            border-radius: 50%;
            border: 1px solid #ffffff;
            margin-left: -8px;
            &:first-child {
              margin-left: 0;
            }
          }
        }
        .text {
          flex-shrink: 0;
          font-weight: 700;
          font-size: 14px;
          line-height: 20px;
          color: white;
        }
      }
    }
    .search-area-container {
      padding: 0px 10px;
      width: 100%;

      .search-area {
        padding: 0px 0px 10px 0px;
        height: auto;
        width: 100%;
        max-height: 48px;
        border-radius: 12px;
        display: flex;
        justify-content: flex-end;

        .el-button {
          border: 0;
          font-style: normal;
          font-weight: 700;
          font-size: 14px !important;
          max-height: 24px;
          min-height: 24px;
          padding: 2px 6px !important;
          width: auto !important;
          background-color: transparent !important;

          span {
            display: flex;
            gap: 5px;
            align-items: center;
          }
        }
      }
    }

    .right-category-wrapper {
      display: flex;
      flex-direction: row;
      background-color: #f1f3f6;
      padding: 10px 10px;
      width: 100%;
      border-radius: 12px;

      .right-category-box {
        display: flex;
        flex-direction: row;
        justify-content: space-around;

        .socialhub-category-passive {
          opacity: 0.5;
          filter: grayscale(100%);
          cursor: not-allowed !important;
          cursor: no-drop !important;
        }

        .socialhub-category {
          background: unset;
          border: unset !important;
          padding: 8px 10px;
          border-radius: 30px;
          margin-right: 6px;
          cursor: pointer;
          font-family: "Roboto";
          color: #8c929c;
          white-space: nowrap;
          display: flex;
          align-items: center;
          transition: all 0.2s ease-in-out;

          .icon-container {
            width: 25px;
            height: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            text-decoration: none;

            i {
              margin-bottom: 0px;
              display: block;
              background-position: 50%;
              background-repeat: no-repeat;
              background-size: contain;
              height: 25px;
              width: 25px;
              cursor: pointer;
              mask-repeat: no-repeat;
              mask-position: center;
            }
          }

          span {
            font-size: 14px;
            font-weight: 500;
            margin-left: 6px;
          }
        }
      }
    }
  }

  #select {
    outline: none;
    width: 100%;
    padding: 2px 10px;
    height: 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 15px;
    cursor: pointer;
    border: 0.5px solid #d6d9d9;
    margin: 8px 8px 8px 8px;
    background: #fbfbfb;
    border-radius: 8px;
    font-weight: 600;
    font-family: "Roboto";
    color: #292f3b;
  }
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}

.component-fade-enter,
.component-fade-leave-to

/* .component-fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
}

@media (max-width: 768px) {
  #event-wrapper {
    .router-container {
      flex: unset;

      #eventbar {
        display: none;
      }
    }

    .left-menu {
      width: 100%;
      display: grid;
      height: 60px;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 10px;
      position: fixed;
      bottom: 0px;

      .left-menu-box {
        margin-top: 4px;

        &:first-child {
          display: none;
        }

        .wrapper {
          .title {
            margin-top: 0px;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .icon-container {
            width: 35px;
            height: 35px;

            i {
              height: 22px;
              width: 22px;
            }
          }
        }
      }
    }

    .right-panel {
      width: 100%;

      .right_inner {
        height: calc(~"100vh - 100px");
        overflow-y: auto;
        position: fixed;
        bottom: 0;
      }
    }

    #select {
      flex: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EventWrapper.vue